import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";
import Panel from "@main/panel-components/Panel";
import Login from "@beeldit/user-and-access/auth/pages/Login";
import { AuthProvider } from "@beeldit/user-and-access/auth/AuthContext";
import React from "react";

import LeaguesPage from "@main/leagues/pages/LeaguesPage";
import { ListActionProvider as LeagueListActionProvider } from "./leagues/actions/list/ListActionContext";
import { CreateActionProvider as LeagueCreateActionProvider } from "./leagues/actions/create/CreateActionContext";
import { RemoveActionProvider as LeagueRemoveActionProvider } from "./leagues/actions/remove/RemoveActionContext";
import { EditActionProvider as LeagueEditActionProvider } from "./leagues/actions/edit/EditActionContext";

import ClubsPage from "@main/clubs/pages/ClubsPage";
import { ListActionProvider as ClubListActionProvider } from "./clubs/actions/list/ListActionContext";
import { CreateActionProvider as ClubCreateActionProvider } from "./clubs/actions/create/CreateActionContext";
import { RemoveActionProvider as ClubRemoveActionProvider } from "./clubs/actions/remove/RemoveActionContext";
import { EditActionProvider as ClubEditActionProvider } from "./clubs/actions/edit/EditActionContext";

import PlayersPage from "@main/players/pages/PlayersPage";
import { ListActionProvider as PlayerListActionProvider } from "./players/actions/list/ListActionContext";
import { CreateActionProvider as PlayerCreateActionProvider } from "./players/actions/create/CreateActionContext";
import { RemoveActionProvider as PlayerRemoveActionProvider } from "./players/actions/remove/RemoveActionContext";
import { EditActionProvider as PlayerEditActionProvider } from "./players/actions/edit/EditActionContext";
import { StatisticsActionProvider as PlayerStatisticsActionProvider } from "./players/actions/statistics/StatisticsActionContext";

import CategoriesPage from "@main/categories/pages/CategoriesPage";
import CategoryDashboardPage from "@main/categories/pages/CategoryDashboardPage";
import { ListActionProvider as CategoryListActionProvider } from "./categories/actions/list/ListActionContext";
import { CreateActionProvider as CategoryCreateActionProvider } from "./categories/actions/create/CreateActionContext";
import { RemoveActionProvider as CategoryRemoveActionProvider } from "./categories/actions/remove/RemoveActionContext";
import { EditActionProvider as CategoryEditActionProvider } from "./categories/actions/edit/EditActionContext";
import { DetailsActionProvider as CategoryDetailsActionProvider } from "./categories/actions/details/DetailsActionContext";
import {
  GenerateGamesContext,
  GenerateGamesProvider,
} from "./categories/actions/generate-games/GenerateGamesContext";

const redirectUrls = {
  admin: "/panel/league/2/categories",
};

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthProvider>
        <div className="App">
          <Outlet />
        </div>
      </AuthProvider>
    ),
    children: [
      {
        path: "/login",
        element: <Login redirectUrls={redirectUrls} />,
      },
      {
        path: "/",
        index: true,
        element: <Navigate to="/panel/leagues" />,
      },
      {
        path: "/panel",
        element: <Panel />,
        children: [
          {
            path: "leagues",
            element: (
              <LeagueListActionProvider>
                <LeagueRemoveActionProvider>
                  <LeagueCreateActionProvider>
                    <LeagueEditActionProvider>
                      <LeaguesPage />
                    </LeagueEditActionProvider>
                  </LeagueCreateActionProvider>
                </LeagueRemoveActionProvider>
              </LeagueListActionProvider>
            ),
          },
          {
            path: "league/:leagueId",
            children: [
              {
                path: "categories",
                element: (
                  <CategoryListActionProvider>
                    <CategoryRemoveActionProvider>
                      <CategoryCreateActionProvider>
                        <CategoryEditActionProvider>
                          <CategoriesPage />
                        </CategoryEditActionProvider>
                      </CategoryCreateActionProvider>
                    </CategoryRemoveActionProvider>
                  </CategoryListActionProvider>
                ),
              },
            ],
          },
          {
            path: "category/:categoryId",
            element: (
              <GenerateGamesProvider>
                <CategoryDetailsActionProvider>
                  <CategoryDashboardPage />
                </CategoryDetailsActionProvider>
              </GenerateGamesProvider>
            ),
          },
          {
            path: "clubs",
            element: (
              <ClubListActionProvider>
                <ClubRemoveActionProvider>
                  <ClubCreateActionProvider>
                    <ClubEditActionProvider>
                      <ClubsPage />
                    </ClubEditActionProvider>
                  </ClubCreateActionProvider>
                </ClubRemoveActionProvider>
              </ClubListActionProvider>
            ),
          },
          {
            path: "players",
            element: (
              <PlayerStatisticsActionProvider>
                <PlayerListActionProvider>
                  <PlayerRemoveActionProvider>
                    <PlayerCreateActionProvider>
                      <PlayerEditActionProvider>
                        <PlayersPage />
                      </PlayerEditActionProvider>
                    </PlayerCreateActionProvider>
                  </PlayerRemoveActionProvider>
                </PlayerListActionProvider>
              </PlayerStatisticsActionProvider>
            ),
          },
        ],
      },
    ],
  },
]);

export function Router() {
  return <RouterProvider router={router} />;
}
